import { Component, OnInit } from '@angular/core';
import { HelperService } from './../../../services/helper.service';
import { PaymentService } from './../../../rest/api/payment.service';
import { PaymentService as PaymentLocalService } from '../../../services/payment/payment.service';
import { AuthService } from '../../../services/auth.service';
import * as _ from 'lodash';
import { Router } from '@angular/router';

@Component({
  selector: 'app-subscription-confirm',
  templateUrl: './subscription-confirm.component.html',
  styleUrls: ['./subscription-confirm.component.scss']
})
export class SubscriptionConfirmComponent implements OnInit {

  packageId: any;
  isCameraPlanEnabled = false;
  plansData: any;

  subscriptionPlan: any;
  cameraPlan: any;
  spacePlan: any;
  taxPercentage = 0;

  loader = true;

  formData: any;
  accessToken: any;
  isSubmitted = false;
  errors = [];
  paymentErrorMessage: any;
  paymentSuccessMessage: any;
  constructor(
    private router: Router,
    public paymentLocalService: PaymentLocalService,
    public paymentService: PaymentService,
    public helperService: HelperService,
    public authService: AuthService
  ) {
    this.accessToken = `Bearer ${this.authService.getAccessToken()}`;
    this.isCameraPlanEnabled = this.paymentLocalService.getCameraPlan() ? true : false;
    this.paymentLocalService.planDataSubscription.subscribe(response => {
      if (response) {
        this.plansData = response;
        this.subscriptionPlan  = _.find(this.plansData, {plan_type: 'subscription' }) ? _.find(this.plansData, {plan_type: 'subscription' }) : false;
        if (this.subscriptionPlan && this.subscriptionPlan.tax) {
          this.taxPercentage = this.subscriptionPlan.tax;
        }
        this.cameraPlan  = _.find(this.plansData, {plan_type: 'camera' });
        this.spacePlan  = _.find(this.plansData, {plan_type: 'space' });
      }
    });
  }

  ngOnInit() {
    this.formData = this.paymentLocalService.getFormData();
  }

  hashCardNumber(cardNumber) {
    if (cardNumber.length > 0) {
      return '********' + cardNumber.substr(cardNumber.length - 4);
    }
    return cardNumber;
  }

  convertDateText(date) {
    if (!date) {
      return date;
    }
    let singleMonth = '';
    let years = '';
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct' , 'Nov', 'Dec'];
    const explodedDate = date.split('/');
    if (explodedDate[0]) {
      const index = explodedDate[0] - 1;
      singleMonth  = months[index];
    }
    if (explodedDate[1]) {
      years = '20' + explodedDate[1];
    }
    return singleMonth + ', ' + years;
  }

  submitPayment() {
    const formData = {
      paymentToken: this.formData.paymentToken,
      registerToken: this.formData.registerToken,
      amount:  this.getTotalPrice(),
    };

    this.isSubmitted = true;
    this.paymentLocalService.renewSubscription(this.accessToken, this.helperService.updateJsonFormat(formData)).subscribe(response => {
      this.authService.setSubscriptionStatus('active');
      this.paymentSuccessMessage = 'Thankyou for your subscription at betaspace. Your account is now activated.';
      this.isSubmitted = false;
    }, err => {
      if (err && err.error && err.error.errors && err.error.errors[0]) {
        this.errors = err.error.errors;
      } else {
        this.paymentErrorMessage = 'There was error while paying for your subscription.';
      }
      this.isSubmitted = false;
    });
  }

  getTotalPrice() {
    return this.getTaxAmount() + this.getSubTotalPrice();
  }

  getSubTotalPrice() {
    const subsriptionPrice = this.subscriptionPlan && this.subscriptionPlan.new_price ? this.subscriptionPlan.new_price : 0;
    const cameraPrice = this.cameraPlan && this.cameraPlan.new_price ? this.cameraPlan.new_price : 0;
    const spacePrice = this.spacePlan && this.spacePlan.new_price ? this.spacePlan.new_price : 0;
    return subsriptionPrice + cameraPrice + spacePrice;
  }

  getTaxAmount() {
    if (this.taxPercentage && this.taxPercentage > 0) {
      const subTotalPrice = this.getSubTotalPrice();
      const taxAmount = subTotalPrice * this.taxPercentage / 100;
      return Math.round(taxAmount);
    }
    return 0;
  }

}
